import * as server from "@/utils/http"


// 获取业务类型
export const _getAcceptableAges=params=> server.get("/applicable-age/list",params)
